module.exports = __webpack_public_path__ + "teqbahn-assets/media/20.dfd30c8b.jpg";